import { useState } from 'react';
import { Link } from 'react-router-dom';
import { securityApi } from '../../api/security';

export function IdentityGovernancePage() {
  const [result, setResult] = useState<string | null>(null);
  const review = async () => {
    const r = await securityApi.createAccessReview({ subject_type: 'user', subject_id: 'admin', reviewer: 'security-admin' });
    setResult(`Access review ${r.id} created (${r.status})`);
  };
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Identity Governance</h1>
      <Link to="/security" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← SOC Hub</Link>
      <div className="mt-6 rounded-xl border p-4 dark:border-slate-700 space-y-3">
        <p className="text-sm text-slate-600 dark:text-slate-400">Manage access certification, privilege review and delegated administration.</p>
        <button type="button" onClick={review} className="rounded bg-indigo-600 px-4 py-2 text-sm text-white hover:bg-indigo-700">Start Access Review</button>
        {result && <p className="text-sm text-indigo-700 dark:text-indigo-400">{result}</p>}
      </div>
    </div>
  );
}
